<template>
    <div class="container">
        <div class="columns is-centered">
            <div class="column is-5-tablet is-4-desktop is-3-widescreen">
                <form action="" class="box">
                    <b-field label="Email">
                        <b-input type="text" v-model="username" placeholder="Email" required
                            @keyup.enter.native="login()" ref="username"></b-input>
                    </b-field>
                    <b-field label="Password">
                        <b-input type="password" v-model="password" password-reveal placeholder="Password" required
                            @keyup.enter.native="login()" ref="password"></b-input>
                    </b-field>
                    <b-button class="button is-light" expanded @click.prevent="login()">Login</b-button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex"
import { UsuarioService } from "../services"
import { Data, Storage, Tools, Validator } from "../util"
import Toast from "../util/toast"
import AppRouter from "../AppRouter"
export default {
    name: "Login",
    data() {
        return {
            username: "",
            password: "",
        }
    },
    computed: {
        ...mapGetters("AppStore", ["url"]),
    },
    methods: {
        login() {
            if (this.username && this.password) {
                if (!this.username.includes("@")) {
                    this.username = this.username.concat("@epcmexperts.com")
                }
                UsuarioService
                    .login(this.username, this.password)
                    .then(
                        response => {
                            if (response) {
                                // para cargar datos que puede ser utilizados en los dropdowns
                                // Data.loadLists()
                                // redirigiendo a la ruta pendiente de login si la hibiera
                                // if (Storage.getObject("to") != null) {
                                //     const to = Storage.getObject("to")
                                //     Storage.remove("to")
                                //     this.$router.push(to.path)
                                // }
                                // else {
                                //     if (Validator.isNotNull(UsuarioService.getUsuario().pve_id)) {
                                //         // * Enrutando hacia las ordenes de compra del proveedor
                                //         this.$router.push({ name: "ProveedorOrdenCompra" })
                                //     }
                                //     else {
                                //         this.$router.push({ name: "Home" })
                                //     }
                                // }
                                AppRouter.push({ name: "Home" })
                            } else {
                                Toast.error("Credenciales incorrectas")
                            }
                        },
                        error => {
                            Toast.error("Credenciales incorrectas")
                            console.error(`error: `, error)
                        }
                    )
            }
        }
    },
    mounted() {
        if (Validator.isNotNull(this.$route.params.message)) {
            // * indicando al usuario que no tiene acceso a la ruta ingresada
            Toast.error(this.$route.params.message)
        }
        else {
            this.$refs.username.focus()
        }
        // if (UsuarioService.getUsuario()) {
        //     // * para borrar todo dato del usuario que ha iniciado sesion anteriormente
        //     UsuarioService.remove()
        // }
    }
}
</script>
<style scoped>
.container {
    animation: slideDown 0.4s ease-out forwards;
}

@keyframes slideDown {
    from {
        transform: translateY(-20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}
</style>
